export const globalStyObj = {
  // 支付页
  '--Fonts-Font-1': '#333',
  '--Fonts-Font-3': '#b2b2b2',
  '--System-Color-White': '#ffffff',
  '--System-Color-White-All': 'rgba(255, 255, 255, 0.7)',
  '--Card-Card-3': '#fefefe',
  '--Fonts-Font-2': '#666',
  '--Divider-Divider1': '#ededed',
  '--General-Red-All-2': '#f00',
  '--Primary-Color-100': '#a338fc',

  // UI规范 - vibeo
  '--fg-white': 'rgba(255, 255, 255, 1)',
  '--fg-black': 'rgba(0, 0, 0, 1)',
  '--fg-text-primary': 'rgba(32, 35, 38, 1)',
  '--fg-text-secondary': 'rgba(53, 58, 63, 1)',
  '--fg-text-tertiary': 'rgba(95, 101, 106, 1)',
  '--fg-text-quaternary': 'rgba(142, 144, 146, 1)',
  '--fg-text-inverse': 'rgba(249, 250, 250, 1)',
  '--fg-icon-primary': 'rgba(32, 35, 38, 1)',
  '--fg-icon-secondary': 'rgba(95, 101, 106, 1)',
  '--fg-icon-disable': 'rgba(164, 165, 168, 1)',
  '--fg-icon-inverse': 'rgba(249, 250, 250, 1)',
  '--border-subtle': 'rgba(227, 228, 229, 1)',
  '--border-default': 'rgba(12, 14, 17, 1)',
  '--border-strong': 'rgba(201, 202, 203, 1)',
  '--border-inverse': 'rgba(255, 255, 255, 1)',
  '--bg-base': 'rgba(240, 241, 242, 1)',
  '--bg-surface': 'rgba(249, 250, 250, 1)',
  '--bg-card': 'rgba(227, 228, 229, 1)',
  '--bg-strong': 'rgba(215, 215, 216, 1)',
  '--bg-white': 'rgba(255, 255, 255, 1)',
  '--bg-black': 'rgba(12, 14, 17, 1)',
  '--bg-btn-default': 'rgba(12, 14, 17, 1)',
  '--bg-btn-default_pressed': 'rgba(43, 47, 51, 1)',
  '--bg-btn-disabled': 'rgba(227, 228, 229, 1)',
  '--bg-btn-inverse': 'rgba(255, 255, 255, 1)',
  '--bg-btn-inverse_pressed': 'rgba(240, 241, 242, 1)',
  '--overlay-subtle': 'rgba(0, 0, 0, 0.2)',
  '--overlay-default': 'rgba(0, 0, 0, 0.6)',
  '--overlay-strong': 'rgba(0, 0, 0, 0.7)',
}
